var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoveaaiLogoWhiteText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220.2 40.3",
    style: {
      enableBackground: "new 0 0 220.2 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000111181920661486662020000011049392256057676695_);}\n\t.st3{fill:url(#SVGID_00000011012028367402259570000001938685883743594388_);}\n\t.st4{fill:url(#SVGID_00000003797975328694289310000014199253236044016311_);}\n\t.st5{fill:none;stroke:#E9006D;stroke-width:3;stroke-miterlimit:10;}\n\t.st6{fill:url(#SVGID_00000128480913967581648420000002040387173034017211_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000111175450739327114830000007299471318505269941_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,24.8c-1.2-5.4,0.4-11.2,1.1-12.9c0.8-1.8,2.5-5,6-7.7c1.1-0.9,4-2.9,8.3-3.8c5.5-1.1,9.9,0.4,11.5,1 c1.3,0.5,7.3,3,10.7,9.6c1.7,3.6,2.1,6.7,2.2,8.9c0,0.9,0,3.5-1,6.5c-0.5,1.4-1.6,4.9-4.6,8c-4.1,4.2-9,5.2-10.4,5.4 c-10.1,1.9-17.5-4.9-18-5.4C4.5,33,1.7,29.8,0.4,24.8L0.4,24.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3072,
    y1: 1086.2393,
    x2: 34.0305,
    y2: 1065.2097,
    gradientTransform: "matrix(1 0 0 1 0 -1048.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0D21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#0C1132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#0B143F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C3D9C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.3,24.6c-0.9,6.6-7.1,16-20.9,14.7l0,0c8,2.6,15.9-0.3,20.4-5.1c6.1-6.4,2.2-13.9,2.2-13.9 c-1.2-2.3-2.5-4.1-4-5.6C34.3,16.7,35.9,20.3,35.3,24.6L35.3,24.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000067194543503801706690000005605384012758426779_",
    cx: -78.5896,
    cy: 1020.8547,
    r: 33.1328,
    gradientTransform: "matrix(0.9923 -0.1241 8.564352e-02 0.6847 -5.5086 -691.4724)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#21D0FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#17B8F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#0A96E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#068ADF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#0481DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#0269D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0057CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067194543503801706690000005605384012758426779_)"
    },
    d: "M30.7,17.6c0.9,7.5-3.7,11.1-7.3,12.2 c0,0-5.4,2.6-13.9-2.4S1.6,11.9,1.6,11.9S-4,25.2,5.9,34.2c2.7,2.5,5.6,4.1,8.5,5.1l0,0c13.9,1.2,20-8.1,20.9-14.7 c0.6-4.3-1-7.9-2.3-9.9c-3.2-3.3-6.9-4.8-9.9-5.5C30,11.4,30.7,17.6,30.7,17.6L30.7,17.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060012041439277855190000003206952067237133989_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.172,
    y1: 1062.2877,
    x2: 38.6978,
    y2: 1062.6484,
    gradientTransform: "matrix(1 0 0 1 0 -1048.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7036B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#7633BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7E31CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#371A6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#311766"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#23114E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#0B0728"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#080623"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060012041439277855190000003206952067237133989_)"
    },
    d: "M37.6,10.3C33,1.6,21.3-2.6,11.5,1.8 S-0.4,16.6,7.7,24.4c2.2,2.1,4.3,3.5,6.3,4.4l0,0c-3.4-1.6-6.3-5.9-5.1-11.7s6.3-7.8,7.9-8.1c0,0,5.3-2.8,13.2,2.1 c9.5,6,9.2,15.4,9.2,15.4S42.3,19,37.6,10.3L37.6,10.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065076489631351761350000001299225312818838168_",
    cx: 8.0049,
    cy: 1058.1754,
    r: 31.2464,
    gradientTransform: "matrix(1 0 0 1 0 -1048.043)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41197E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#3C1777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#311364"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#1E0D46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#080623"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065076489631351761350000001299225312818838168_)"
    },
    d: "M31.9,10.7c-8.1-6.9-20-5.3-24.5,0.8 c-2.5,3.4-3,6.6-2.9,8.8c0.8,1.4,1.8,2.8,3.2,4c2.2,2.1,4.3,3.5,6.3,4.4c-3.4-1.6-6.3-5.9-5.1-11.7s6.3-7.8,7.9-8.1 c0,0,5.3-2.8,13.2,2.1c9.5,6,9.2,15.4,9.2,15.4C39.4,25.5,40,17.7,31.9,10.7L31.9,10.7z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.4,29.8C23.4,29.8,23.4,29.8,23.4,29.8C23.4,29.8,23.4,29.8,23.4,29.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094584463507717485500000011676268276015243916_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.6224,
    y1: 1067.5123,
    x2: 30.8298,
    y2: 1067.5123,
    gradientTransform: "matrix(1 0 0 1 0 -1048.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#121827"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#0D0F1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094584463507717485500000011676268276015243916_)"
    },
    d: "M8.9,17c-1.2,5.8,1.7,10.1,5.1,11.7l0,0 c5.1,2.2,9.1,1.2,9.4,1.1c0,0,0,0,0,0c3.6-1.1,8.3-4.8,7.3-12.2c0,0-0.7-6.2-7.5-8.4c-3.6-0.8-6.4-0.3-6.4-0.3 C15.2,9.3,10.2,11.3,8.9,17L8.9,17z M15,12.4c1.9,0,3.4,1.5,3.4,3.4s-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4 C11.6,13.9,13.1,12.4,15,12.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000109010345150787485850000000996319544112517521_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,10.3v8.4h14.7v5.9H60.6v11.5h-7.3V4.4h23.9v5.9H60.6L60.6,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.9,23.9c0-7.3,5.7-12.5,13.4-12.5s13.3,5.2,13.3,12.5S99,36.4,91.3,36.4S77.9,31.2,77.9,23.9z M97.4,23.9 c0-4.2-2.7-6.7-6.2-6.7c-3.5,0-6.2,2.5-6.2,6.7s2.7,6.7,6.2,6.7C94.8,30.7,97.4,28.1,97.4,23.9L97.4,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.4,11.8l-10.3,24.3h-7.3l-10.2-24.3h7.3l6.7,16.6l7-16.6L131.4,11.8L131.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.9,25.9h-18.4c0.7,3,3.3,4.9,7,4.9c2.6,0,4.4-0.8,6.1-2.4l3.8,4.1c-2.3,2.6-5.7,3.9-10,3.9 c-8.4,0-13.9-5.3-13.9-12.5s5.6-12.5,13-12.5S156,16.2,156,24C156,24.6,155.9,25.3,155.9,25.9L155.9,25.9z M137.4,21.8h12 c-0.5-3.1-2.8-5.1-6-5.1S137.9,18.7,137.4,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,22.2v13.9h-6.6v-3c-1.3,2.2-3.8,3.4-7.4,3.4c-5.7,0-9.1-3.2-9.1-7.4s3-7.3,10.4-7.3h5.6 c0-3-1.8-4.8-5.6-4.8c-2.6,0-5.2,0.9-7,2.3l-2.5-4.9c2.7-1.9,6.6-2.9,10.5-2.9C175.9,11.4,180.2,14.8,180.2,22.2z M173.1,28.4v-2.5 h-4.8c-3.3,0-4.3,1.2-4.3,2.8c0,1.8,1.5,2.9,4,2.9C170.3,31.7,172.3,30.6,173.1,28.4L173.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207,27.2h-18.4l-4,8.9h-2.5l14.6-31.7h2.3l14.6,31.7h-2.5L207,27.2L207,27.2z M206.1,25.2L197.8,7l-8.3,18.3 H206.1L206.1,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.9,4.4h2.3v31.7h-2.3V4.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoveaaiLogoWhiteText);
export default __webpack_public_path__ + "static/media/foveaai_logo_white_text.45bc8ef4686a910649011a72c1688c69.svg";
export { ForwardRef as ReactComponent };